import React, { useMemo } from 'react'
import styled from 'styled-components'
import { useUserState } from '~/atoms/UserState'
import Text, { FontStyle } from '~/components/core/Text'
import ListItem from '~/components/ListItem'
import { getLabelData } from '~/utils/callLogUtils'

import { CallLog } from '@mangovoice/types'

const LocateWrapper = styled.span`
  display: flex;
  align-items: center;

  > div:first-child {
    margin-right: 5px;
  }
`
interface CallLogEntryProps {
  call: CallLog
  selectedCallId?: number
  onCallLogSelected: (entry: CallLog) => void
}

const CallLogEntry = ({
  call: logEntry,
  selectedCallId,
  onCallLogSelected,
}: CallLogEntryProps) => {
  const { currentUserExtensionId: userExtensionId } = useUserState()

  const labelData = useMemo(() => {
    return getLabelData(logEntry)
  }, [logEntry, userExtensionId])

  const selected = selectedCallId === logEntry.id
  const title = (
    <Text
      as="span"
      fontStyle={FontStyle.Normal}
      text={labelData.title}
      weight="normal"
      color="var(--chakra-colors-fg-default)"
    />
  )

  const subTitle = useMemo(() => {
    const DirectionIcon = labelData.directionIcon
    return (
      <LocateWrapper>
        <DirectionIcon
          size={10}
          color={
            labelData.missed
              ? 'var(--chakra-colors-red-solid)'
              : 'var(--chakra-colors-fg-muted)'
          }
        />
        <Text
          as="span"
          fontStyle={FontStyle.Tiny}
          text={`${labelData.subTitle.replace(labelData.subTitleSubject, '')}`}
          color="var(--chakra-colors-fg-muted)"
        />
        <Text
          as="span"
          style={{ whiteSpace: 'pre' }}
          fontStyle={FontStyle.Tiny}
          text={` ${labelData.subTitleSubject}`}
          color="var(--chakra-colors-fg-default)"
          weight="normal"
        />
      </LocateWrapper>
    )
  }, [logEntry, userExtensionId])

  return (
    <ListItem
      key={`call-log-id-${logEntry.id}`}
      activated={selected}
      title={title}
      subTitle={subTitle}
      date={
        <Text
          as="span"
          fontStyle={FontStyle.Tiny}
          text={labelData.date}
          color="var(--chakra-colors-fg-subtle)"
        />
      }
      time={
        <Text
          as="span"
          fontStyle={FontStyle.Tiny}
          text={labelData.duration}
          color="var(--chakra-colors-fg-subtle)"
        />
      }
      onClick={() => onCallLogSelected(logEntry)}
    />
  )
}

export default CallLogEntry
